"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function NotAuthenticatedMessage(_ref) {
  var title = _ref.title,
      loginUrl = _ref.loginUrl,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "page--multifaceted-bg-grey"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "not-auth-message"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    icon: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "info circle large"
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, title), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/" + loginUrl + "?redirect=" + encodeURIComponent( // $FlowFixMe
    document.location)
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, null, buttonText))))));
}

var _default = NotAuthenticatedMessage;
exports["default"] = _default;